import {DialogPosition} from '@angular/material/dialog';

export interface MenuItem {
  name: string;
  route?: string;
  iconType?: string;
  icon: string;
  permission?: string[];
  url?: string;
  count?: string;
  children?: MenuItem[];
}

export interface Menu {
  moduleName?: string;
  moduleIcon?: string;
  menuItems: MenuItem[];
}

export interface SvgIcon {
  name: string;
  tag: string;
}

export interface ResponseCode {
  code: number;
  description: string;
}

export interface PageableParam {
  first?: number;
  size?: number;
  sortBy?: string;
  sortDirection?: string;
  searchFields?: SearchFieldsDtoInput[];
}

export interface SearchFieldsDtoInput {
  fieldName?: string;
  fieldValue?: string;
  fieldValues?: string[];
  searchType?: SearchOperationType;
}


export enum SearchOperationType {
  Equals = 'Equals',
  GreaterThan = 'GreaterThan',
  In = 'In',
  LessThan = 'LessThan',
  Like = 'Like',
  NotEquals = 'NotEquals',
  Between = 'Between',
  IsNull = 'IsNull',
  IsNotNull = 'IsNotNull',
}


export enum TimeRangesEnum {
  Hourly = 'Hourly',
  Daily = 'Daily',
  Weekly = 'Weekly',
  Monthly = 'Monthly'
}


export const initializedPageableParameter = {
  first: 0,
  size: 10,
  sortBy: 'id',
  sortDirection: 'DESC',
};

export const specialInitializedPageableParameter = {
  first: 0,
  size: 450,
  sortBy: 'id',
  sortDirection: 'DESC',
};

export interface AttachmentDtoInput {
  id?: number;
  createdAt?: string;
  fullPath?: string;
  dataBinary?: string | ArrayBuffer;
  sourceName?: string;
  filePath?: string;
  attachmentTitle?: string;
  attachmentType?: string;
  data?: string | ArrayBuffer;
  sourceUid?: string;
}

export interface AttachmentSharable {
  attachmentBase64: string;
  attachmentType?: string;
  description?: string;
  title?: string;
  uuid?: string;
  attachmentUuid?: string;
  sourceUid?: string;
}

export interface OpenDialog {
  data?: any;
  component: any;
  width?: string;
  panelClass?: string[];
  position?: DialogPosition;
  height?: string;
}

export const rating = [
  {name: 'FAIR', value: 'FAIR'},
  {name: 'GOOD', value: 'GOOD'},
  {name: 'VERY GOOD', value: 'VERYGOOD'},
];

export interface ProfileStatus {
  isFilled: boolean;
  isRequired: boolean;
  itemName: string;
}

export const tzPhone = '(255|0)[^0123459]([0-9]{8})';

export const generalPhoneNumber = '[0-9]{6,}';


export enum SearchOperation {
  BTN = 'BTN',
  EQ = 'EQ',
  GT = 'GT',
  GTE = 'GTE',
  ILK = 'ILK',
  IN = 'IN',
  LK = 'LK',
  LT = 'LT',
  LTE = 'LTE',
  ME = 'ME',
  MS = 'MS',
  NE = 'NE',
  NIN = 'NIN'
}

export enum Direction {
  ASC = 'ASC',
  DESC = 'DESC'
}

export interface DataRequestInputInput {
  fields?: FieldRequestInputInput[];
  mustHaveFilters?: MandatoryFilterInputInput[];
  page?: number;
  pageSize?: number;
}

export interface FieldRequestInputInput {
  fieldName?: string;
  isSearchable?: boolean;
  isSortable?: boolean;
  operation?: SearchOperation;
  orderDirection?: Direction;
  searchValue?: string;
  searchValue2?: string;
}

export interface MandatoryFilterInputInput {
  fieldName?: string;
  inValues?: string[];
  isNull?: boolean;
  operation?: SearchOperation;
  value1?: string;
  value2?: string;
}


export interface OrganizationHierarchyNode {
  id?: number;
  uuid?: string;
  name: string;
  code: string;
  children?: OrganizationHierarchyNode[];
}

export interface FlatTreeNode {
  expandable: boolean;
  name: string;
  level: number;
}

export interface AuthTokenModel {
  access_token: string;
  token_type: string;
  refresh_token?: string;
  expires_in: number;
  scope: string;
  success: boolean;
  massage: string;
  user: any;
  error: string;
}

export interface AuthBodyModel {
  username: string;
  password: string;
  grant_type: string;
  client_id?: string;
  client_secret?: string;
}

export interface ActionButton {
  id: string;
  label: string;
  icon?: string;
  image?: string;
  title: string;
  textColor?: string;
  class?: string;
  loading_message?: string;
  confirm_message?: string;
  confirm_first?: boolean;
  action: string; // unique action that will be emitted to you
}

export enum IconTypeEnum{
  SVG = 'SVG', MATERIAL = 'MATERIAL'
}

export enum FormValueTypeEnum{
  TEXT = 'TEXT',
  AMOUNT = 'AMOUNT',
  NUMBER = 'NUMBER',
  SELECTOR = 'SELECTOR',
  DATE = 'DATE',
  EMAIL = 'EMAIL',
  URL = 'URL',
  TEL = 'TEL',
}

export interface DialogButtons {
  title?: string;
  value?: any;
}


export interface DialogData {
  icon?: string;
  iconType?: IconTypeEnum;
  title?: string;
  message?: string;
  placeholder?: string;
  isForm?: boolean;
  formFieldType?: FormValueTypeEnum;
  dialogValue?: any;
  buttons?: DialogButtons[];
}

export interface ResponseObject {
  id: any;
  status: boolean;
  code: any;
  message: string;
}

export interface BaseResponse<T> {
  response?: ResponseObject;
  data?: T;
  page?: PageMetadataObject;
}


export interface PageMetadataObject {
  number?: number;
  hasNextPage?: boolean;
  hasPreviousPage?: boolean;
  currentPageNumber?: number;
  nextPageNumber?: number;
  previousPageNumber?: number;
  numberOfPages?: number;
  totalElements?: number;
  pagesNumberArray?: number[];
}

export interface PageResult {
  number: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  nextPageNumber: number;
  previousPageNumber: number;
  totalElements: number;
  numberOfPages: number;
}


export interface EnvInterface {
  production: boolean,
  INDEXED_DB_VERSION: number,
  AUTH_SERVER_URL: string,
  MEDIA_SERVER_URL?: string,
  SERVER_URL: string,
  ALLOW_PERMISSIONS: boolean,
  CLIENT_ID: string,
  CLIENT_SECRET: string,
  GRANT_TYPE: string,
  PLATFORM_ID: string,
  SESSION_TIMEOUT: number;
}


export interface PaginatedFilteringInput {
  uniqueId?: string;
  pageNumber?: number
  itemsPerPage?: number
  keyword?: string;
}


export const compareByDate = (a: any, b: any): number => {
  const dateA = new Date(a.createdDate);
  const dateB = new Date(b.createdDate);
  if (dateA < dateB) {
    return -1;
  }
  if (dateA > dateB) {
    return 1;
  }
  return 0;
};


export interface LocationCoordinates {
  title: string;
  longitude: string;
  latitude: string
}
